
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/object-remover",
      function () {
        return require("private-next-pages/object-remover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/object-remover"])
      });
    }
  